import { Label } from '@/components/ui/label'
import { Skeleton } from '@/components/ui/skeleton'

export const DockerImageInputFallback = () => (
  <div className="w-full">
    <Label>Registry credential (optional)</Label>
    <Skeleton className="h-9 w-full mt-2" />
    <Skeleton className="h-3 w-full mt-2 mb-1" />
    <Skeleton className="h-3 w-[120px] mb-3" />
  </div>
)
